import {useForm} from "react-hook-form";
import isEmail from "validator/es/lib/isEmail";
import {useContext, useState} from "react";
import {CustomerInterface} from "../../interfaces/customer/CustomerInterface";
import {updateAfterPhoneCode} from "../../api/customer";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {vkGoal} from "../checkout/utils/marketing/Service";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {useNavigate} from "react-router-dom";


export default function RegistrationByPhoneOnly({customer, setError, setLoading, setCustomer}: {
    customer: CustomerInterface,
    setError: Function,
    setLoading: Function,
    setCustomer: Function
}) {

    const [agree, setAgree] = useState(true);
    const [agreeLoyalty, setAgreeLoyalty] = useState(true);
    const [agreePhoneCommunication, setAgreePhoneCommunication] = useState(false);
    const [agreeEmailCommunication, setAgreeEmailCommunication] = useState(false);

    const {register, getValues, formState: {errors, dirtyFields}} = useForm({
        mode: "onChange"
    });

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const navigate = useNavigate();


    const updateUser = () => {

        let fields = getValues()
        fields = {
            ...fields, ...{
                agree_loyalty: agreeLoyalty,
                agree_phone_communication: agreePhoneCommunication,
                agree_email_communication: agreeEmailCommunication,
                id: customer.id,
                sign: customer.sign,
                phone: customer.phone
            }
        }

        updateAfterPhoneCode(fields).then(status => {
            setCustomer(status.user)
            if (state.nextAction === 'goToCabinet') {
                navigate('/personal-area/')
            }
            dispatch({type: ReducerActionType.CLOSE_ALL_POPUP})
            dispatch({type: ReducerActionType.SET_PARAM, paramName: 'nextAction', payload: ''})

        }).catch(error => {
            setError(error.response?.data?.detail || error.response?.data?.message)
        }).finally(() => {
            setLoading(false)
            vkGoal('complete_registration')
        })
    }

    return (<form>
        <h6 className="modal-form__title f-exp">Завершение авторизации</h6>

        <div className="form-group">
            <label className="form-label">ФИО</label>
            <input type="text"
                   className={'form-control ' + (errors.first_name ? ' is-invalid ' : '') + (!errors.first_name && dirtyFields.first_name ? ' is-valid ' : '')}
                   placeholder="введите имя" {...register("first_name", {required: true})}/>
            <br/>
            <input type="text"
                   className={'form-control ' + (errors.last_name ? ' is-invalid ' : '') + (!errors.last_name && dirtyFields.last_name ? ' is-valid ' : '')}
                   placeholder="введите фамилию" {...register("last_name", {required: true})}/>
        </div>
        <div className="form-group">
            <label className="form-label">E-mail</label>
            <input type="text"
                   className={'form-control ' + (errors.email ? ' is-invalid ' : '') + (!errors.email && dirtyFields.email ? ' is-valid ' : '')}
                   placeholder="введите email" {...register("email", {required: true, validate: { checkEmail: v => !v || isEmail(v) } })}/>
        </div>

        <div className="form-policy-agree">
            <div className="form-checkbox ">
                <input className="hidden" id="check-enter-reg" type="checkbox" checked={agree}/>
                <label className="label-dot" onClick={() => {
                    setAgree(!agree)
                }}></label>
                <p>Нажимая кнопку “Отправить”, Вы соглашаетесь с <a href="/landing/26/">Политикой
                    конфиденциальности</a> и <a
                    href="/landing/27/">Политикой обработки cookies</a></p>
            </div>
            <div className="form-checkbox mt-3">
                <input className="hidden" id="check-enter-reg" type="checkbox" checked={agreeLoyalty}/>
                <label className="label-dot" onClick={() => {
                    setAgreeLoyalty(!agreeLoyalty)
                }}></label>
                <p>Даю согласие на участие в программе лояльности</p>
            </div>
            <div className="form-checkbox mt-3">
                <input className="hidden" id="check-enter-reg" type="checkbox" checked={agreePhoneCommunication}/>
                <label className="label-dot" onClick={() => {
                    setAgreePhoneCommunication(!agreePhoneCommunication)
                }}></label>
                <p>Даю согласие на получение рассылок по SMS</p>
            </div>
            <div className="form-checkbox mt-3">
                <input className="hidden" id="check-enter-reg" type="checkbox" checked={agreeEmailCommunication}/>
                <label className="label-dot" onClick={() => {
                    setAgreeEmailCommunication(!agreeEmailCommunication)
                }}></label>
                <p>Даю согласие на получение рассылок по Email</p>
            </div>
        </div>

        <div className="form-btns mt-4">
            <button type={'button'} className="btn btn-secondary" disabled={!agree || !agreeLoyalty} onClick={updateUser}>Продолжить</button>
        </div>

    </form>)
}